export default __webpack_public_path__ + "static/treatmentareas-stomachbefore-aeea9a5904b9fa4ec42de744fb2e0bba.webp";